if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.main_product_id = document.querySelector('.product-variant-id').getAttribute('value');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      // Add event listener for size variant selection to auto-remove warning
      this.addSizeVariantListener();
    }

    addSizeVariantListener() {
      const sizeVariantList = document.getElementById('product-size-variant-list');
      if (sizeVariantList) {
        const sizeRadios = sizeVariantList.querySelectorAll('input[type="radio"][name="Size"]');
        sizeRadios.forEach(radio => {
          radio.addEventListener('change', () => {
            // Auto-remove warning when size is selected
            this.clearErrorMessage();
          });
        });
      }
    }

    clearErrorMessage() {
      // Find error wrapper using the same logic as in onSubmitHandler
      let errorWrapper = this.querySelector('.product-form__error-message-wrapper');
      
      if (!errorWrapper) {
        errorWrapper = this.closest('.product').querySelector('.product-form__error-message-wrapper');
      }
      if (!errorWrapper) {
        errorWrapper = document.querySelector('.product-form__error-message-wrapper');
      }
      
      if (errorWrapper) {
        errorWrapper.setAttribute('hidden', '');
        errorWrapper.style.display = '';
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Check if size variant is selected
      const sizeVariantList = document.getElementById('product-size-variant-list');
      if (sizeVariantList) {
        const sizeRadios = sizeVariantList.querySelectorAll('input[type="radio"][name="Size"]');
        const isSizeSelected = Array.from(sizeRadios).some(radio => radio.checked);
        
        if (!isSizeSelected) {          
          // Try to find error wrapper in different scopes
          let errorWrapper = this.querySelector('.product-form__error-message-wrapper');
          let errorMessage = this.querySelector('.product-form__error-message');
          
          // If not found in this element, try in parent or document
          if (!errorWrapper) {
            errorWrapper = this.closest('.product').querySelector('.product-form__error-message-wrapper');
          }
          if (!errorWrapper) {
            errorWrapper = document.querySelector('.product-form__error-message-wrapper');
          }
          
          if (!errorMessage && errorWrapper) {
            errorMessage = errorWrapper.querySelector('.product-form__error-message');
          }
          
          if (errorWrapper && errorMessage) {
            // Set the error message text
            errorMessage.textContent = 'Please select the size';
            // Remove hidden attribute
            errorWrapper.removeAttribute('hidden');
            // Force display with inline style as backup
            errorWrapper.style.display = 'flex';
            errorWrapper.style.alignItems = 'flex-start';
            errorWrapper.style.fontSize = '1.2rem';
            errorWrapper.style.marginTop = '1.5rem';
          } else {
            // As a fallback, create and show an alert or temporary message
            alert('Please select the size');
          }
          
          return;
        }
      }

      // Check recipient block validation if present for this product form
      const recipientBlock = document.querySelector(`gift-card-recipient[data-product-form-id="${this.form.id}"]`);
      if (recipientBlock && typeof recipientBlock.validateAll === 'function') {
        if (!recipientBlock.validateAll()) {
          return;
        }
        if (typeof recipientBlock.syncNativeProperties === 'function') {
          recipientBlock.syncNativeProperties();
        }
      }

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      let formData;
      const checkbox = document.getElementById("myCheckbox");
      if (checkbox && checkbox.checked) {
        formData = {
          items: [],
        };
        let obj = {};
        obj["id"] = this.main_product_id;
        obj["quantity"] = 1;
        formData.items.push(obj);
        var variantIdElements = document.querySelectorAll(".variant-id");
          variantIdElements.forEach(function (element) {
            var variantId = element.getAttribute("data-variant-id");
            let obj = {};
          obj["id"] = parseInt(variantId);
          obj["quantity"] = 1;
          formData.items.push(obj);
          });
        formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
        formData['sections_url'] = window.location.pathname;
        config.body = JSON.stringify(formData);
        config.headers['Content-Type'] = "application/json";
      } else {
        formData = new FormData(this.form);
        // Ensure recipient block properties outside this.form are included in formData
        if (recipientBlock) {
          const recipientInputs = recipientBlock.querySelectorAll('input[name^="properties["], textarea[name^="properties["]');
          recipientInputs.forEach((input) => {
            if (!input.disabled && input.name && input.value !== '' && !formData.has(input.name)) {
              formData.append(input.name, input.value);
            }
          });
        }
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData; 
      }
      fetch(`${routes.cart_add_url}${this.addOns? ".js":""}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.form.dispatchEvent(new CustomEvent('product-form:completed', { bubbles: true, detail: { error: this.error } }));
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        this.errorMessageWrapper.removeAttribute('hidden');
      } else {
        this.errorMessageWrapper.setAttribute('hidden', '');
      }
    }
  });
}